//
//
//
//
//
//
//
//
//
//
//
import rewardList from "./component/rewardList.vue";
import rewardRule from "./component/rewardRule.vue";
export default {
  name: "rewardController",
  components: {
    rewardList: rewardList,
    rewardRule: rewardRule
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'rewardList'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};